export const NumberOfYearlyPaymentsOptions = [12, 14, 15].map((value) => ({
  value,
  display: value,
}));
